<template>
  <div id="wrap" class="nisc-wrap iso-wrap">
    <div id="krds-skip-link">
      <a href="#container">본문 바로가기</a>
    </div>
    <header id="krds-header" style="border: none;">
      <LayoutTop :isPCMenuOpen.sync="isPCMenuOpen"/>
    </header>
    <div id="container">
      <div v-if="$route.path!='/'" id="main" class="nisc-container">
        <div id="container">
          <div class="inner in-between">
            <!-- 사이드바영역-->
            <LayoutLeft />
            <!-- 컨텐츠영역 -->
            <div class="contents">
              <nav class="krds-breadcrumb-wrap align-right" aria-label="현재 경로" id="breadcrumb">
                <ol class="breadcrumb">
                  <li class="home" ><a href="/" class="txt">홈</a></li>
                  <li v-if="subMenuBreadcrumb != null && subMenuBreadcrumb != ''" class="breadCrumbBr1" ><a class="txt">{{$sanitize($t(subMenuBreadcrumb))}}</a></li>
                  <li v-if="subMenuTitle != null && subMenuTitle != ''" class="breadCrumbBr2"><a class="txt">{{$sanitize($t(subMenuTitle))}}</a></li>
                  <li v-if="subMenuBreadcrumbTitle != null && subMenuBreadcrumbTitle != ''" class="breadCrumbBr3"><a class="txt">{{$sanitize($t(subMenuBreadcrumbTitle))}}</a></li>
                </ol>
              </nav>
              <section class="content-wrap">
                <h2 class="section-title lg"  v-html="$sanitize($t(subMenuTitle))"></h2>
                <router-view />
              </section>
            </div>
          </div>
        </div>
      </div>
      <main v-if="$route.path=='/'" id="main" class="nisc-container">
        <div class="inner">
          <section class="main-section-01">
              <div class="main-swiper-wrap">
                <div class="swiper" id="main-swiper">
                    <ul ref="mainSwiper" class="swiper-wrapper custom-banner" :options="swiperOption">
                      <li v-for="(item, index) in mainSlideList" class="swiper-slide"  :key="`bg0${index+1}`" :style="doSwiperStyle(item)">
                        <a>
                          <div v-html="$sanitize(item.content)"></div>
                        </a>
                      </li>
                    </ul>
                </div>
              </div>
          </section>
          <section class="main-section-02 grid-2">
            <div class="main-board-list">
              <h2 class="section-title">
                자료실
                <a class="txt-more curs-p"  @click="doContentLink('M0013', 'M0004')">
                  더 보기
                </a>
              </h2>
              <ul class="dotted-list line-height-2">
                <li v-for="(item, index) in noticeList" :key="`li_${index}`" class="truncate curs-p">
                  <a @click="doBoardMainLink(item)" :title="`화면이동-${item.title}`">{{item.title}}</a>
                </li>
              </ul>
            </div>

            <div class="main-quick-menu">
              <h2 class="section-title">주요메뉴 바로가기</h2>
              <ul class="quick-menus grid-5">
                <li v-for="(item, index) in slide1List.slice(0,5)" :key="index" >
                  <a :href="item.url" :title="item.url != null && item.url != ''?(item.newWinYn=='Y'?'새창열림':'화면이동'):''" :target="item.newWinYn=='Y'?'_blank':''" >
                    <div class="img-wrap">
                      <img :src="item.imgUrl" alt="" />
                    </div>
                    <p>{{ item.title }}</p>
                  </a>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>
    <LayoutFooter :organ="organ" :snsLinkList="snsLinkList"/>
    <div class="gnb-backdrop" :class="{ active: isPCMenuOpen }"></div>
    <div class="floating-menu">
      <button type="button" class="go-top__btn" @click="doScrollTop"></button>
    </div>
    <template v-if="$route.path =='/'">
      <template v-for="(item, index) in layerPopupList">
        <div v-if="doCookie(item)" class="layer-popup-main" :style="item.layerStyle != null? item.layerStyle :doLayerStyle(item)" :key="index">
          <div v-html="item.content" class="layerCont"></div>
          <div class="today-close">
            <ul>
              <input type="checkbox" v-if="item.nextCloseYn == 'Y'" v-model="item.layerNextCloseYn" true-value="Y" false-value="N" >
              <label for="next_close" v-if="item.nextCloseYn == 'Y'">{{ item.nextCloseDd }}{{$t('nextCloseDdText')}}</label>
              <input type="button" value="닫기" @click="doNextClose(item, item.layerNextCloseYn)" class="ct_bt01" >
            </ul>
          </div>
        </div>
      </template>
    </template>
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex'
import 'swiper/css/swiper.css'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import LayoutTop from '@/views/layouts/LayoutTop.vue'
import LayoutFooter from '@/views/layouts/LayoutFooter.vue'
import LayoutLeft from '@/views/layouts/LayoutLeft.vue'

export default {
  components: {
    LayoutTop,
    LayoutFooter,
    LayoutLeft,
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mainSwiper.$swiper;
    },
    swiper2() {
      return this.$refs.swiper2;
    },
    ...mapGetters([
      'subMenuTitle',
      'subMenuBreadcrumb',
      'subMenuBreadcrumbTitle',
    ]),
  },
  created() {
    this.doMainContent();
    this.doMain()
  },
  data() {
    return {
      layerPopupList: [],
      windowPopupList: [],
      topLinkList:[],
      snsLinkList:[],
      noticeList: [],
      siteList:[],
      mainSlideList: [],
      slide1List: [],
      orgModalClass: '',
      organ: {
        orgCd: null,
        orgNm: null,
        addr: null,
        tel: null,
        email: null
      },
      swiperOption: {
        loop: true,
        autoplay: {
            delay: 3000,
        },
        speed: 1000,
        slidesPerView: 1,
        navigation: {
          prevEl: '.main-slider .swiper-button-prev',
          nextEl: '.main-slider .swiper-button-next',
        },      
      },
      isPCMenuOpen: false
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    doContentLink(menuId, upMenuId) {
      this.$router.push({name:'isoti_content', query: {menuId: menuId, upMenuId: upMenuId, s0: null}})
    },
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > 50) {
          document.body.classList.add("scroll");
        } else {
          document.body.classList.remove("scroll");
        }
      const wrap = document.getElementById("wrap");
      if (!wrap) return;

      const currentScroll = window.scrollY;

      if (currentScroll > this.lastScroll) {
        wrap.classList.add("scroll-down");
        wrap.classList.remove("scroll-up");
      } else if (currentScroll < this.lastScroll) {
        wrap.classList.add("scroll-up");
        wrap.classList.remove("scroll-down");
      }

      this.lastScroll = currentScroll;
    },
    doTopDeptLink(){
      this.$router.push({
      path: this.$route.path,
      query: this.$route.query,
      params: this.$route.params
    });
    },
    doScrollTop() {
      window.scrollTo({top:0, behavior:'smooth'});
    },
    doTopLink(){
      this.$router.push({
      path: this.$route.path,
      query: this.$route.query,
      params: this.$route.params
    });
    },
    doBoardMainLink(item) {
      const depthArr = item.menuDepth ? item.menuDepth.split(',') : []
      const upMenuId = depthArr.length > 0 ? depthArr[0] : null
      const menuId = depthArr.length > 1 ? depthArr[1] : null
      const param = {name:'isoti_dynamicDetail', query: {menuId: menuId, upMenuId: upMenuId, postNo: item.postNo}}

      for(const key in item.queryDepth) {
        param.query[key] = item.queryDepth[key]
      }
      this.$router.push(param)
    },
    doMainContent() {
      this.$tran('/site/external/main/selectMainContentIso', '').then(response => {
        this.snsLinkList = response.data.snsLinkList;
        this.topLinkList = response.data.topLinkList;
        this.layerPopupList = response.data.layerPopupList;
        this.windowPopupList = response.data.windowPopupList;
        this.siteList = response.data.siteList;

        this.$nextTick(() => {
          if(this.windowPopupList != null && this.windowPopupList.length > 0 && this.$route.path =='/eng') {
            this.doWindowPopup();
          }
        })
      })
    },
    doMain() {
      this.$tran('/site/external/main/selectMainIso', {}).then(response => {
        this.slide1List = response.data.slide1List;
        this.mainSlideList = response.data.mainSlideList;
        this.noticeList = response.data.noticeList;
        this.organ = response.data.organ;
      })
    },
    closeGardenModal() {
      this.orgModalClass = [];
      this.$store.dispatch('setPopupInfo', 'N');
    },
    doSwiperStyle(item) {
      return {'background-image': `url("${encodeURI(item?.imgUrl)}")`, 'background-size':'cover'}
    },
    doCookie(item) {
      const data = this.$cookies.get(item.popupNo);

      if(data != null) {
        return false;
      }
      return true;
    },
    doNextClose(item, layerNextCloseYn) {
      if(layerNextCloseYn == 'Y') {
        this.$cookies.set(item.popupNo, 'Y', `${item.nextCloseDd}d`);
      }
      
      this.doLayerClose(item);
    },
    doLayerClose(item) {
      item.layerStyle.display = 'none';
    },
    doLayerStyle(item) {
      const width = item.widthPixel;
      const height = item.heightPixel;
      const left = item.leftPixel;
      const top = item.topPixel;

      const layerStyle = {
        backgroundImage: `url(${encodeURI(item?.imgUrl)})`,
        width: `${width}px`,
        height: `${Number(height)+30}px`,
        left: `${left}px`,
        top: `${top}px`,
        display: 'block',
        'background-size': 'contain',
        backgroundRepeat: 'no-repeat'
      }

      this.$set(item, 'layerStyle', layerStyle);
    },
    doSlideLink(url) {
      if(url != null && url != '') {
        return url
      }

      return false
    },
    doWindowPopup() {
      for(let i=0; i < this.windowPopupList.length; i++) {
        const getCookie = this.doCookie(this.windowPopupList[i]);

        if(getCookie) {
          const data = this.windowPopupList[i]
          const popupNo = data.popupNo;
          const imgUrl = data.imgUrl;
          const width = data.widthPixel;
          let height = data.heightPixel;
          const left = data.leftPixel;
          const top = data.topPixel;
          const content = data.content;
          const nextCloseDd = data.nextCloseDd;
          const nextCloseYn = data.nextCloseYn;

          
          if(height != null && typeof height == 'string'){
            const intData = height.replaceAll(/(-)[^\d.]/gi, '')
            if(intData != null && intData != ''){
              height = (parseFloat(intData) + 30) + height.replaceAll(/[-\d.]/gi,'')
            }
          }
          
          const win = window.open('', popupNo, `location=no,width=${width},height=${height},top=${top},left=${left}`);

          if(win.document.querySelector('.newPopupDiv') != null) {
            win.document.querySelector('.newPopupDiv').remove();
            win.document.querySelector('.popup').remove();
          }

          if(win.document.querySelector('.footer') != null) {
            win.document.querySelector('.footer').remove();
          }

          if(win.document.querySelector('script') != null) {
            win.document.querySelector('script').remove();
          }

          if(win.document.querySelector('style') != null) {
            win.document.querySelector('style').remove();
          }
          
          const htmlTag = `
                    <style>
                      body {
                        margin: 0px;
                      }

                      img {
                        width: 100%;
                      }

                      p br{
                        display:none;
                      }

                      table, pre,div {
                        color: #575757; 
                        font-size: 1em;
                      }

                      .newPopupDiv {
                        height: calc(100% - 30px);
                        width: 100%;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-image: url(${encodeURI(imgUrl)});
                      }

                      #next_close {
                        margin-top: 9px;
                      }

                      div.popup {
                        clear: both;
                        position: relative;
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        text-align: right;
                      }

                      div.popup .ct_bt01 {
                        margin-right:10px;
                        margin-left:10px;
                      }

                      @media(max-width: 736px) {
                        .mmimg_w {
                          width:100% !important;
                          height: calc(100% - 30px) !important;
                          top: 0 !important;
                          left: 0 !important;
                        }

                        .mmimg_w, .mmimg_in, .mmmimg{
                          width: 100% !important;
                          height: calc(100% - 30px) !important;
                        }

                        .mmmimg p, .mmmimg img {
                          width: 100% !important;
                          height: auto;
                        }
                      }
                  </style>
                  <div>
                    <div class="mmmimg newPopupDiv">
                      ${content==null?'':content}
                    </div> 
                    <div class="popup">
                      ${nextCloseYn=='Y'? `<input type="checkbox" id="next_close">${nextCloseDd} ${this.$t('nextCloseDdText')}`:''}
                      <input type="button" value="닫기" onClick="closeToday()" class="ct_bt01">
                    </div>  
                  </div> 
                  <script type="text/javascript">
                    function closeToday() {
                      ${nextCloseYn=='Y'? `var isNextClose = document.getElementById('next_close').checked;

                      if(isNextClose) {
                        var todayDate = new Date();
                        todayDate.setDate( todayDate.getDate() + ${nextCloseDd} );
                        document.cookie = name + "= Y" + "; path=/; expires=" + todayDate.toGMTString() + ";"
                      }
                      `:''}
                      window.close();
                    }
                  <\/script>`;
          win.document.write(htmlTag);
        }
      }
    }, 
    doModalBackKeyDown(e) {
      if(e.shiftKey && e.keyCode == 9){
        e.preventDefault();
        document.querySelector("#homepage_move").focus()
      }
    },
    doModalKeyDown(e) {
      if(!e.shiftKey && e.keyCode == 9){
        e.preventDefault();
        document.querySelector("#modalFirst").focus()
      }
    }
  },
}
</script>